<section class="buy-wifi-email text-white">
   <app-error></app-error>
   <div class="modal" id="myModal" style="display: block">
      <div class="modal-dialog medium">
         <div class="modal-content">
            <div class="modal-header">
               <button type="button" class="modal-close" data-modal-close="wifi-onboard-switch"
                  (keydown.enter)="closePaySelectionOverlay()"
                  (click)="closePaySelectionOverlay()" tabindex="0" id="close-switch"
                  [attr.aria-label]="('close' | translate)">×</button>
               <h4 class="modal-title" id="switch-header">{{'paySelection.header' | translate}}</h4>
            </div>
            <div class="modal-body">
               <div class="switch-content-wrapper">
                  <p [innerHtml]="'paySelection.instruction' | translate"></p>
                  <div class="wrap-button paySelect-points-container">
                     <button class="btn primary small small-12 switch-buy-more" id="switch-buy-more"
                        (click)="redirectToPointsBuywifi()">{{'paySelection.paywithPoints' |
                        translate}}</button>
                  </div>
                  <div class="wrap-button paySelect-card-container">
                     <button class="btn primary small small-12 switch-buy-more" id="switch-buy-more"
                        (click)="redirectToBuywifi()">{{'paySelection.paywithCard' |
                        translate}}</button>
                  </div>
                  <!--<p [innerHtml]="'ebCampaign.instruction' | translate" id="ebCampInst"></p>-->
               </div>
            </div>
         </div>
      </div>
   </div>
</section>